// Generated by Melange

import * as Belt__Belt_Array from "melange.belt/belt_Array.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";

function useReducer(initialState, reducer) {
  const match = React.useReducer((function (fullState, action) {
    const state = Curry._2(reducer, action, fullState.state);
    if (/* tag */ typeof state === "number" || typeof state === "string") {
      return fullState;
    }
    switch (state.TAG) {
      case /* Update */ 0 :
        return {
          state: state._0,
          sideEffects: fullState.sideEffects
        };
      case /* UpdateWithSideEffects */ 1 :
        return {
          state: state._0,
          sideEffects: {
            contents: Belt__Belt_Array.concat(fullState.sideEffects.contents, [state._1])
          }
        };
      case /* SideEffects */ 2 :
        return {
          state: fullState.state,
          sideEffects: {
            contents: Belt__Belt_Array.concat(fullState.sideEffects.contents, [state._0])
          }
        };
    }
  }), {
    state: initialState,
    sideEffects: {
      contents: []
    }
  });
  const send = match[1];
  const match$1 = match[0];
  const sideEffects = match$1.sideEffects;
  const state = match$1.state;
  React.useEffect((function () {
    if (sideEffects.contents.length === 0) {
      return;
    }
    const sideEffectsToRun = sideEffects.contents.slice(0, undefined);
    sideEffects.contents = [];
    const cancelFuncs = Belt__Belt_Array.keepMap(sideEffectsToRun, (function (func) {
      return Curry._1(func, {
        send: send,
        state: state
      });
    }));
    if (cancelFuncs.length !== 0) {
      return (function (param) {
        Belt__Belt_Array.forEach(cancelFuncs, (function (func) {
          Curry._1(func, undefined);
        }));
      });
    }
    
  }), [sideEffects]);
  return [
    state,
    send
  ];
}

function useReducerWithMapState(getInitialState, reducer) {
  const match = React.useReducer((function (fullState, action) {
    const state = Curry._2(reducer, action, fullState.state);
    if (/* tag */ typeof state === "number" || typeof state === "string") {
      return fullState;
    }
    switch (state.TAG) {
      case /* Update */ 0 :
        return {
          state: state._0,
          sideEffects: fullState.sideEffects
        };
      case /* UpdateWithSideEffects */ 1 :
        return {
          state: state._0,
          sideEffects: {
            contents: Belt__Belt_Array.concat(fullState.sideEffects.contents, [state._1])
          }
        };
      case /* SideEffects */ 2 :
        return {
          state: fullState.state,
          sideEffects: {
            contents: Belt__Belt_Array.concat(fullState.sideEffects.contents, [state._0])
          }
        };
    }
  }), undefined, (function (param) {
    return {
      state: Curry._1(getInitialState, undefined),
      sideEffects: {
        contents: []
      }
    };
  }));
  const send = match[1];
  const match$1 = match[0];
  const sideEffects = match$1.sideEffects;
  const state = match$1.state;
  React.useEffect((function () {
    if (sideEffects.contents.length === 0) {
      return;
    }
    const sideEffectsToRun = sideEffects.contents.slice(0, undefined);
    sideEffects.contents = [];
    const cancelFuncs = Belt__Belt_Array.keepMap(sideEffectsToRun, (function (func) {
      return Curry._1(func, {
        send: send,
        state: state
      });
    }));
    if (cancelFuncs.length !== 0) {
      return (function (param) {
        Belt__Belt_Array.forEach(cancelFuncs, (function (func) {
          Curry._1(func, undefined);
        }));
      });
    }
    
  }), [sideEffects]);
  return [
    state,
    send
  ];
}

export {
  useReducer,
  useReducerWithMapState,
}
/* react Not a pure module */
